"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @deprecated This class is overkill, just use DOMPurify
 */
class HtmlEntityStringUtil {
    static withInput(input) {
        return new HtmlEntityStringUtil(input.trim());
    }
    constructor(input) {
        this.buffer = [];
        const matches = input.match(HtmlEntityStringUtil.ENTITY_REGEX);
        if (!matches || matches.length === 0) {
            this.addToBuffer(input);
        }
        else {
            let last = 0;
            matches.forEach((match) => {
                const start = input.indexOf(match, last);
                if (start >= last) {
                    this.addToBuffer(input.substring(last, start));
                }
                this.buffer.push(match);
                last = start + match.length;
            });
            if (last < input.length - 1) {
                this.addToBuffer(input.substring(last));
            }
        }
    }
    hyphenate(tolerance, position, hyphen) {
        let hyphenated = "";
        for (let i = 0; i < this.buffer.length; i++) {
            if (this.toleranceExceeded(tolerance) && i > 0 && i % position === 0) {
                hyphenated += hyphen;
            }
            hyphenated += this.buffer[i];
        }
        return hyphenated;
    }
    addToBuffer(str) {
        for (let i = 0; i < str.length; i++) {
            this.buffer.push(str.charAt(i));
        }
    }
    toleranceExceeded(tolerance) {
        return this.buffer.length > tolerance;
    }
}
HtmlEntityStringUtil.ENTITY_REGEX = /&[a-z]+;|&#[0-9]+;|&#x[0-9a-fA-F]+;/gim;
exports.default = HtmlEntityStringUtil;
//# sourceMappingURL=HTMLEntityStringUtil.js.map